import api from "./api";

export const formatDateTime = (dateString) => {
  if (dateString == null) {
    return "N/A";
  }
  const date = new Date(dateString);
  return date.toLocaleString("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });
};

export const apiRequest = async (
  endpoint ,
  method = "GET",
  data = null,
  extraHeaders = {}
) => {
  const config = {
    url: endpoint,
    method,
    headers: {
      ...extraHeaders,
    },
  };

  // Attach body if exists
  if (data) {
    if (!(data instanceof FormData)) {
      // ✅ headers is now typed
      (config.headers )["Content-Type"] =
        "application/json";
    }
    config.data = data; // ✅ data now allowed
  }

  try {
    const response = await api(config);
    return response.data;
  } catch (error) {
    console.error("API request failed:", error);
    throw error;
  }
};
